import React, { useState } from 'react';
import { Button, Menu, MenuItem, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_CUSTOMER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';
import BulkUploadButton from '../../bulkUpload/components/BulkUploadButton';

function CustomerListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const { customers: c } = useTranslatedMessages();
  const actions = c?.list_actions ?? {};
  const accessDeniedMessage = useAccessDeniedMessage();
  const canCreate = hasEInvoicePermission(CREATE_CUSTOMER);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateAction = (type) => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    handleClose();
    navigate(`/customers/create?customerType=${type}`);
  };

  return (
    <>
      <Stack direction="row" spacing={1}>
        <BulkUploadButton
          category="CUSTOMER"
          requiredPermission={CREATE_CUSTOMER}
          redirectAfterSubmit="/sales/bulk-upload"
        />
        <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
          <Button
            data-testid="create-customer-button"
            key="add-new-customer"
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={!canCreate}
          >
            {actions.create_new ?? '+ Create New Customer'}
          </Button>
        </PermissionDeniedWrapper>
      </Stack>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem data-testid="create-individual-customer" onClick={() => handleCreateAction('INDIVIDUAL')}>
          {actions.create_individual ?? 'Individual Customer'}
        </MenuItem>
        <MenuItem data-testid="create-business-customer" onClick={() => handleCreateAction('BUSINESS')}>
          {actions.create_business ?? 'Business Customer'}
        </MenuItem>
      </Menu>
      <SubscriptionModal />
    </>
  );
}

export default CustomerListPageActions;
